// @ts-nocheck
function isValidEmail(email) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
}

// areaLength     = dígitos de DDD/área quando o prefixo não está em twoDigitAreas
// inputLength    = quantos dígitos o campo visível exige para ser válido
// nationalLength = tamanhos aceitos na hora de montar o E.164
const PHONE_COUNTRY_CONFIG = {
  BR: {
    dialCode: '55',
    areaLength: 2,
    nationalLength: [10, 11],
    inputLength: [11],
    mobilePrefix: '',
  },
  MX: {
    dialCode: '52',
    areaLength: 3,
    twoDigitAreas: ['55', '33', '81'],
    nationalLength: [10],
    inputLength: [10],
    mobilePrefix: '',
  },
  AR: {
    dialCode: '54',
    areaLength: 3,
    twoDigitAreas: ['11'],
    nationalLength: [10],
    inputLength: [10],
    mobilePrefix: '9',
    stripMobile15: true,
  },
  CO: {
    dialCode: '57',
    areaLength: 3,
    nationalLength: [10],
    inputLength: [10],
    mobilePrefix: '',
  },
};

function getPhoneCountry(root) {
  const explicit = (root?.dataset.entryPhoneCountry || '').trim().toUpperCase();
  if (PHONE_COUNTRY_CONFIG[explicit]) return explicit;

  const nacionalidade = (root?.dataset.hsNacionalidade || '').trim().toLowerCase();
  if (nacionalidade.includes('colomb')) return 'CO';
  if (nacionalidade.includes('argent')) return 'AR';
  if (nacionalidade.includes('xico') || nacionalidade.includes('mexico')) return 'MX';
  if (nacionalidade.includes('brasil') || nacionalidade.includes('brazil')) return 'BR';

  return 'BR';
}

const UNKNOWN_PHONE_CONFIG = {
  dialCode: '',
  areaLength: 2,
  nationalLength: [10, 11, 12, 13],
  inputLength: [10, 11, 12, 13],
  mobilePrefix: '',
};

function getPhoneConfig(country) {
  return PHONE_COUNTRY_CONFIG[country] || UNKNOWN_PHONE_CONFIG;
}

function getAreaLength(digits, config) {
  const twoDigitAreas = config.twoDigitAreas || [];
  if (twoDigitAreas.includes(digits.slice(0, 2))) return 2;
  return config.areaLength || 3;
}

function getInputLengths(config) {
  return config.inputLength || config.nationalLength || [10, 11];
}

function stripMobile15(digits, config) {
  if (!config.stripMobile15) return digits;
  const areaLength = getAreaLength(digits, config);
  if (digits.slice(areaLength, areaLength + 2) === '15') {
    return digits.slice(0, areaLength) + digits.slice(areaLength + 2);
  }
  return digits;
}

function normalizePhoneDigits(value, config) {
  let digits = (value || '').replace(/\D/g, '').replace(/^0+/, '');
  if (!digits) return '';
  return stripMobile15(digits, config);
}

function isValidPhone(value, country) {
  const config = getPhoneConfig(country);
  const digits = normalizePhoneDigits(value, config);
  return getInputLengths(config).includes(digits.length);
}

// Máscara única para os quatro países: o tamanho da área vem da config e os
// quatro últimos dígitos ficam sempre depois do hífen.
// BR (11) 98765-4321 · MX (55) 1234-5678 · AR (351) 123-4567 · CO (300) 123-4567
function formatPhoneDisplay(value, country) {
  const config = getPhoneConfig(country);
  const maxDigits = Math.max(...getInputLengths(config));
  const digits = (value || '').replace(/\D/g, '').slice(0, maxDigits);
  if (!digits) return '';

  const areaLength = getAreaLength(digits, config);
  if (digits.length <= areaLength) return `(${digits}`;

  const area = digits.slice(0, areaLength);
  const rest = digits.slice(areaLength);
  if (rest.length <= 4) return `(${area}) ${rest}`;

  const cut = rest.length - 4;
  return `(${area}) ${rest.slice(0, cut)}-${rest.slice(cut)}`;
}

function formatPhoneForHubSpot(value, country) {
  const config = getPhoneConfig(country);
  const dial = config.dialCode;
  const rawDigits = (value || '').replace(/\D/g, '').replace(/^0+/, '');
  if (!rawDigits) return '';

  const minNational = Math.min(...config.nationalLength);
  if (dial && rawDigits.startsWith(dial) && rawDigits.length >= dial.length + minNational) {
    return `+${rawDigits}`;
  }

  const digits = stripMobile15(rawDigits, config);

  if (config.nationalLength.includes(digits.length)) {
    return `+${dial}${config.mobilePrefix || ''}${digits}`;
  }

  return `+${digits}`;
}

// A HubSpot recebe o telefone como texto puro: só dígitos, sem +, ( ) ou -.
function toDigitsOnly(value) {
  return (value || '').replace(/\D/g, '');
}

// Monta o valor que vai na propriedade de telefone da HubSpot.
// withCountryCode = false envia só o número nacional (ex.: 51997526292).
function buildHubSpotPhoneValue(phoneE164, country, withCountryCode) {
  const digits = toDigitsOnly(phoneE164);
  if (!digits) return '';
  if (withCountryCode) return digits;

  const dial = getPhoneConfig(country).dialCode;
  if (dial && digits.startsWith(dial) && digits.length > dial.length) {
    return digits.slice(dial.length);
  }
  return digits;
}

function splitFullName(fullName) {
  const parts = fullName.trim().split(/\s+/).filter(Boolean);
  if (!parts.length) return { firstname: '', lastname: '' };
  if (parts.length === 1) return { firstname: parts[0], lastname: '' };
  return { firstname: parts[0], lastname: parts.slice(1).join(' ') };
}

function buildHubSpotContactField(name, value) {
  return { objectTypeId: '0-1', name, value };
}

function getHubspotUtkCookie() {
  const match = document.cookie.match(/(^|;\s*)hubspotutk=([^;]*)/);
  return match ? decodeURIComponent(match[2]) : '';
}

function buildHubSpotFormContext(options = {}) {
  const ctx = {
    pageUri: options.pageUri ?? window.location.href,
    pageName: options.pageName ?? (document.title || window.location.pathname),
  };
  if (options.ipAddress) ctx.ipAddress = options.ipAddress;
  // hutk vazio faz a API rejeitar o envio — só entra no contexto se o cookie existir.
  if (options.hutk) ctx.hutk = options.hutk;
  return ctx;
}

const UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'];
const UTM_STORAGE_KEY = 'madesa_bf_utm';

function readUtmsFromUrl() {
  const params = new URLSearchParams(window.location.search);
  const utms = {};
  UTM_KEYS.forEach((key) => {
    const value = (params.get(key) || '').trim();
    if (value) utms[key] = value;
  });
  return utms;
}

// Guarda as UTMs da primeira URL da sessão: se a pessoa navegar pelo site
// antes de enviar o formulário, a atribuição não se perde.
function persistUtms() {
  const fromUrl = readUtmsFromUrl();
  if (!Object.keys(fromUrl).length) return;
  try {
    sessionStorage.setItem(UTM_STORAGE_KEY, JSON.stringify(fromUrl));
  } catch (error) {}
}

function getUtms() {
  const fromUrl = readUtmsFromUrl();
  if (Object.keys(fromUrl).length) return fromUrl;
  try {
    const stored = sessionStorage.getItem(UTM_STORAGE_KEY);
    return stored ? JSON.parse(stored) : {};
  } catch (error) {
    return {};
  }
}

function getHeroBfI18nStrings(form) {
  const el = form.querySelector('[data-hero-bf-i18n]');
  if (!el) return {};
  try {
    return JSON.parse(el.textContent);
  } catch {
    return {};
  }
}

function showStatus(form, message) {
  const statusEl = form.querySelector('[data-hero-bf-status]');
  if (!statusEl) return;
  statusEl.hidden = false;
  statusEl.textContent = message;
}

function clearStatus(form) {
  const statusEl = form.querySelector('[data-hero-bf-status]');
  if (!statusEl) return;
  statusEl.hidden = true;
  statusEl.textContent = '';
}

const initHeroBfForm = (form) => {
  if (!form || form.dataset.heroBfInit === 'true') return;
  form.dataset.heroBfInit = 'true';

  const STR = getHeroBfI18nStrings(form);
  const submitBtn = form.querySelector('.hero-bf-form__button');
  const submitLabelEl = form.querySelector('[data-hero-bf-submit-label]');
  const submitLabelDefault = submitLabelEl ? submitLabelEl.textContent.trim() : '';

  // Campos visíveis: não têm name, para não conflitarem com o form nativo do Shopify.
  const nameInput = form.querySelector('[data-hero-bf-name]');
  const emailInput = form.querySelector('input[name="contact[email]"]');
  const phoneInput = form.querySelector('[data-hero-bf-phone]');

  // Campos ocultos que o Shopify realmente recebe.
  const firstNameField = form.querySelector('input[name="contact[first_name]"]');
  const lastNameField = form.querySelector('input[name="contact[last_name]"]');
  const phoneField = form.querySelector('input[name="contact[phone]"]');

  const phoneCountry = getPhoneCountry(form);

  const hsPortalId = (form.dataset.hsPortalId || '39596724').trim();
  const hsFormId = (form.dataset.hsFormId || '8533e2b8-fa54-406c-90cb-a8485393fce5').trim();
  const hsPhoneField = (form.dataset.hsPhoneField || 'phone').trim();
  const hsNacionalidade = (form.dataset.hsNacionalidade || '').trim();
  const hsOrigemStaging = (form.dataset.hsOrigemStaging || '').trim();
  const hsPhoneWithCountry = (form.dataset.hsPhoneWithCountry || 'true').trim() !== 'false';

  let submitting = false;

  function isNameValid() {
    if (!nameInput) return true;
    return nameInput.value.trim().length >= 3;
  }

  function isEmailValid() {
    if (!emailInput) return true;
    return isValidEmail(emailInput.value.trim());
  }

  function isPhoneValid() {
    if (!phoneInput) return true;
    return isValidPhone(phoneInput.value, phoneCountry);
  }

  function isFormValid() {
    return isNameValid() && isEmailValid() && isPhoneValid();
  }

  function syncButton() {
    if (!submitBtn) return;
    submitBtn.classList.toggle('ativo', isFormValid());
  }

  const setSubmitting = (isSubmitting) => {
    if (!submitBtn) return;
    submitBtn.disabled = isSubmitting;
    if (submitLabelEl) {
      submitLabelEl.textContent = isSubmitting ? STR.submitLoading || 'Enviando...' : submitLabelDefault;
    }
  };

  function buildHubSpotFields({ email, firstname, phoneDigits }) {
    const fields = [
      buildHubSpotContactField('email', email),
      buildHubSpotContactField('firstname', firstname),
      buildHubSpotContactField(hsPhoneField, toDigitsOnly(phoneDigits)),
      buildHubSpotContactField('madesa_email_consent', 'true'),
    ];

    if (hsNacionalidade) {
      fields.push(buildHubSpotContactField('nacionalidade', hsNacionalidade));
    }
    if (hsOrigemStaging) {
      fields.push(buildHubSpotContactField('origem_de_cadastro_staging', hsOrigemStaging));
      fields.push(buildHubSpotContactField('origem_de_cadastro__crm__staging', hsOrigemStaging));
    }

    // UTM vazia não entra: enviar string vazia apagaria a atribuição
    // que o contato já tinha de uma campanha anterior.
    const utms = getUtms();
    UTM_KEYS.forEach((key) => {
      if (utms[key]) fields.push(buildHubSpotContactField(key, utms[key]));
    });

    return fields;
  }

  // Dispara e esquece: nao podemos bloquear o submit nativo, senao o script
  // de captcha do Shopify nao consegue injetar o token. keepalive mantem a
  // requisicao viva mesmo com a pagina navegando.
  function sendToHubSpot(payloadData) {
    if (!hsPortalId || !hsFormId) return;

    fetch(`https://api.hsforms.com/submissions/v3/integration/submit/${hsPortalId}/${hsFormId}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payloadData),
      keepalive: true,
    })
      .then(function (response) {
        if (!response.ok) {
          console.error('[hero-bf] HubSpot recusou o envio', response.status);
        }
      })
      .catch(function (error) {
        console.error('[hero-bf] Falha ao enviar para a HubSpot', error);
      });
  }

  if (phoneInput) {
    phoneInput.addEventListener('input', () => {
      phoneInput.value = formatPhoneDisplay(phoneInput.value, phoneCountry);
      syncButton();
    });
  }

  [nameInput, emailInput].forEach((input) => {
    if (!input) return;
    input.addEventListener('input', syncButton);
  });

  form.addEventListener('submit', (event) => {
    // Reenvio disparado pelo captcha do Shopify: deixa passar sem repetir nada.
    if (submitting) return;

    clearStatus(form);

    const nome = ((nameInput || {}).value || '').trim();
    const email = ((emailInput || {}).value || '').trim();
    const phone = ((phoneInput || {}).value || '').trim();

    if ((nameInput && !nome) || (emailInput && !email) || (phoneInput && !phone)) {
      event.preventDefault();
      showStatus(form, STR.validationRequiredFields || '');
      return;
    }
    if (nameInput && nome.length < 3) {
      event.preventDefault();
      showStatus(form, STR.validationFullName || '');
      return;
    }
    if (emailInput && !isValidEmail(email)) {
      event.preventDefault();
      showStatus(form, STR.validationEmail || '');
      return;
    }
    if (phoneInput && !isPhoneValid()) {
      event.preventDefault();
      showStatus(form, STR.validationPhone || '');
      return;
    }

    const phoneE164 = formatPhoneForHubSpot(phone, phoneCountry);
    if (phoneInput && !phoneE164) {
      event.preventDefault();
      showStatus(form, STR.validationPhone || '');
      return;
    }

    const { firstname, lastname } = splitFullName(nome);

    // 1) Shopify: preenche os ocultos que o form de cliente recebe.
    if (firstNameField) firstNameField.value = firstname || nome;
    if (lastNameField) lastNameField.value = lastname;
    if (phoneField) phoneField.value = phoneE164;

    // 2) HubSpot: sai em paralelo, sem segurar o submit.
    sendToHubSpot({
      fields: buildHubSpotFields({
        email,
        firstname: firstname || nome,
        phoneDigits: buildHubSpotPhoneValue(phoneE164, phoneCountry, hsPhoneWithCountry),
      }),
      context: buildHubSpotFormContext({ hutk: getHubspotUtkCookie() }),
    });

    submitting = true;
    setSubmitting(true);

    // Sem preventDefault: o submit nativo segue seu curso e o captcha do
    // Shopify intercepta normalmente, como faria em qualquer form do tema.
  });

  syncButton();
};

const COUPON_COPIED_ICON =
  '<svg width="24" height="18" viewBox="0 0 24 18" fill="none" xmlns="http://www.w3.org/2000/svg">' +
  '<path d="M7.4375 14.125L21.5625 0L23.4375 1.875L7.4375 17.875L0 10.4375L1.875 8.5625L7.4375 14.125Z" fill="#F4F5F5"/>' +
  '</svg>';

// navigator.clipboard só existe em contexto seguro; o fallback cobre a
// pré-visualização do editor de tema e navegadores antigos.
function copyToClipboard(text) {
  if (navigator.clipboard && window.isSecureContext) {
    return navigator.clipboard.writeText(text);
  }

  return new Promise(function (resolve, reject) {
    try {
      const area = document.createElement('textarea');
      area.value = text;
      area.setAttribute('readonly', '');
      area.style.position = 'fixed';
      area.style.top = '-1000px';
      area.style.opacity = '0';
      document.body.appendChild(area);
      area.select();
      const copied = document.execCommand('copy');
      document.body.removeChild(area);
      if (copied) resolve();
      else reject(new Error('copy-failed'));
    } catch (error) {
      reject(error);
    }
  });
}

function bindCouponCopy(button) {
  if (!button || button.dataset.heroBfCopyInit === 'true') return;
  button.dataset.heroBfCopyInit = 'true';

  const couponCode = (button.getAttribute('data-coupon-code') || '').trim();
  const labelEl = button.querySelector('[data-coupon-button-label]') || button.querySelector('span');
  const iconEl = button.querySelector('.hero-bf-coupon-group__icon-copy');
  if (!couponCode || !labelEl) return;

  // Os rótulos vêm do editor de tema; o texto atual do botão é o fallback.
  const defaultLabel = (button.getAttribute('data-coupon-label') || labelEl.textContent || '').trim();
  const copiedLabel = (button.getAttribute('data-coupon-copied-label') || defaultLabel).trim();
  const defaultIcon = iconEl ? iconEl.innerHTML : '';
  let resetTimer = null;

  button.addEventListener('click', function () {
    copyToClipboard(couponCode).then(
      function () {
        labelEl.textContent = copiedLabel;
        if (iconEl) iconEl.innerHTML = COUPON_COPIED_ICON;

        clearTimeout(resetTimer);
        resetTimer = setTimeout(function () {
          labelEl.textContent = defaultLabel;
          if (iconEl) iconEl.innerHTML = defaultIcon;
        }, 2000);
      },
      function () {}
    );
  });
}

const bootHeroBf = (root = document) => {
  persistUtms();
  root.querySelectorAll('[data-hero-bf-form]').forEach(initHeroBfForm);
  root.querySelectorAll('.hero-bf-coupon-group__copy').forEach(bindCouponCopy);
};

document.addEventListener('DOMContentLoaded', () => bootHeroBf());
document.addEventListener('shopify:section:load', (event) => bootHeroBf(event.target));
